import React from 'react';
import Category from 'components/products/Category';
import { getProductCategory } from 'data/categories';

export default () => {
  const cartProductCategory = getProductCategory();

  return cartProductCategory.map((category) => <Category key={category.name} {...category} />);
};
